export default __webpack_public_path__ + "static/media/Information-Active.a691405f.svg";